import { render, staticRenderFns } from "./Rubrica.vue?vue&type=template&id=1f3732fd"
import script from "./Rubrica.vue?vue&type=script&lang=js"
export * from "./Rubrica.vue?vue&type=script&lang=js"
import style0 from "./Rubrica.vue?vue&type=style&index=0&id=1f3732fd&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports